import { render, staticRenderFns } from "./PaymentSelector.vue?vue&type=template&id=12f3faa2&scoped=true"
import script from "./PaymentSelector.vue?vue&type=script&lang=js"
export * from "./PaymentSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f3faa2",
  null
  
)

export default component.exports